import { createApiActions, ApiActions } from "../../shared/store/actions";
import { 
  ACCESS
} from '../../shared/constants';

/**
 * Api actions for access
 */
export const ACCESS_API_ACTIONS: ApiActions = createApiActions(ACCESS);
